var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex gap-8 flex-row flex-wrap view-image"},[_vm._l((_vm.viewFileList),function({ url, fileName },key){return [(
					['png', 'jpg', 'jpeg', 'bmp', 'gif'].indexOf(
						url.substring(url.lastIndexOf('.') + 1)
					) !== -1
				)?_c('div',{key:key + '0'},[(_vm.edit)?_c('div',{staticClass:"relative img-preview w-60 h-60"},[_c('el-image',{staticClass:"w-60 h-60",attrs:{"src":url,"fit":'contain'}}),_c('span',{staticClass:"handle",style:({
							height: _vm.height,
							width: _vm.width
						})},[_c('span',[_c('em',{staticClass:"iconfont mr-12 cursor-pointer",on:{"click":function($event){return _vm.preview(url)}}},[_vm._v("")]),_c('em',{staticClass:"iconfont cursor-pointer",on:{"click":function($event){return _vm.$emit('delete', url)}}},[_vm._v("")])])])],1):_c('div',[_c('el-image',{style:({
							height: _vm.height,
							width: _vm.width
						}),attrs:{"src":url,"fit":'contain',"preview-src-list":[url]}})],1)]):_c('div',{key:key},[_c('div',{staticClass:"el-icon-tickets"}),_c('a',{attrs:{"href":"javascript:;","title":fileName},on:{"click":function($event){return _vm.openDownload({
							fileName,
							url
						})}}},[_vm._v(_vm._s(fileName))])])]}),(_vm.showViewer)?_c('el-image-viewer',{attrs:{"on-close":_vm.closeViewer,"url-list":_vm.previewList}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }